type NodeActivationEvent = {
  key: string
  target: EventTarget | null
  currentTarget: EventTarget | null
}

export const isNodeActivationKey = ({ key, target, currentTarget }: NodeActivationEvent): boolean => {
  if (target !== currentTarget) return false
  return key === 'Enter' || key === ' '
}
